import { authStorage } from "@penn/web-common";
import { KN_PER_LBF } from "@penn/shared-types/domain/installation-force";

// Display/input unit for the Selector force range (MICS-164). API values stay kN.
export type ForceUnit = "kN" | "lbf";

export const FORCE_UNIT_STORAGE_KEY = "PennForceUnit";

/** Lars Q7b: NA works in lbf; EU and ASIA in kN. */
export function defaultForceUnit(region: string): ForceUnit {
  return region === "NA" ? "lbf" : "kN";
}

/** The unit the user explicitly chose this browser session, if any. */
export function readStoredForceUnit(): ForceUnit | null {
  const stored = authStorage.getItem(FORCE_UNIT_STORAGE_KEY);
  return stored === "kN" || stored === "lbf" ? stored : null;
}

export function writeStoredForceUnit(unit: ForceUnit): void {
  authStorage.setItem(FORCE_UNIT_STORAGE_KEY, unit);
}

/** kN → whole lbf for display. */
export function knToLbf(kn: number): number {
  return Math.round(kn / KN_PER_LBF);
}

/**
 * lbf → kN to the whole newton, fine enough that the typed lbf reads back
 * unchanged. A minimum rounds down and a maximum up, so a value typed in lbf
 * never cuts off a machine at the boundary.
 */
export function lbfToKn(lbf: number, round: "down" | "up"): number {
  const newtons = lbf * KN_PER_LBF * 1000;
  return (round === "down" ? Math.floor(newtons) : Math.ceil(newtons)) / 1000;
}
